export const RosterStatusType = {
  UPLOADING: 'uploading',
  VALIDATING: 'validating',
  IMPORTING: 'importing',
  SUCCESS: 'success',
  FAILED: 'failed'
};

export const rosterStatusTypeFromString = (type) => {
  const lower = (type || '').toLowerCase();
  switch (lower) {
    case RosterStatusType.UPLOADING:
    case RosterStatusType.VALIDATING:
    case RosterStatusType.IMPORTING:
    case RosterStatusType.SUCCESS:
    case RosterStatusType.FAILED:
      return lower;
    default:
      throw Error(`Invalid roster status type: ${type}`);
  }
};
